"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRTLList;

// This list tracks which languages should display in Right-to-Left format by default
// When a new language is added, be sure to update this list.
// These values are intentionally hard-coded
// Should the following language be displayed in RTL by default?
// 'ar-EG' yes
// 'ar-JO' yes
// 'bg-BG'
// 'cs-CZ'
// 'da-DK'
// 'de-DE'
// 'el-GR'
// 'en-US'
// 'es-ES'
// 'fi-FI'
// 'fr-FR'
// 'he-IL' yes
// 'hu-HU'
// 'it-IT'
// 'ja-JP'
// 'ko-KR'
// 'lv-LV'
// 'nb-NO'
// 'nl-NL'
// 'pl-PL'
// 'pt-BR'
// 'pt-PT'
// 'ru-RU'
// 'sv-SE'
// 'tr-TR'
// 'zh-HANS'
// 'zh-HANT'
// 'zh-YUE'
function getRTLList() {
  var rtlList = ['ar-EG', 'ar-JO', 'ar-SA', 'he-IL'];
  return rtlList;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9sb2NhbGl6YXRpb24vZ2V0UlRMTGlzdC50cyJdLCJuYW1lcyI6WyJnZXRSVExMaXN0IiwicnRsTGlzdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBO0FBQ0E7QUFFQTtBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFFZSxTQUFTQSxVQUFULEdBQWdDO0FBQzdDLE1BQU1DLE9BQU8sR0FBRyxDQUFDLE9BQUQsRUFBVSxPQUFWLEVBQW1CLE9BQW5CLEVBQTRCLE9BQTVCLENBQWhCO0FBRUEsU0FBT0EsT0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyIvLyBUaGlzIGxpc3QgdHJhY2tzIHdoaWNoIGxhbmd1YWdlcyBzaG91bGQgZGlzcGxheSBpbiBSaWdodC10by1MZWZ0IGZvcm1hdCBieSBkZWZhdWx0XG4vLyBXaGVuIGEgbmV3IGxhbmd1YWdlIGlzIGFkZGVkLCBiZSBzdXJlIHRvIHVwZGF0ZSB0aGlzIGxpc3QuXG5cbi8vIFRoZXNlIHZhbHVlcyBhcmUgaW50ZW50aW9uYWxseSBoYXJkLWNvZGVkXG5cbi8vIFNob3VsZCB0aGUgZm9sbG93aW5nIGxhbmd1YWdlIGJlIGRpc3BsYXllZCBpbiBSVEwgYnkgZGVmYXVsdD9cbi8vICdhci1FRycgeWVzXG4vLyAnYXItSk8nIHllc1xuLy8gJ2JnLUJHJ1xuLy8gJ2NzLUNaJ1xuLy8gJ2RhLURLJ1xuLy8gJ2RlLURFJ1xuLy8gJ2VsLUdSJ1xuLy8gJ2VuLVVTJ1xuLy8gJ2VzLUVTJ1xuLy8gJ2ZpLUZJJ1xuLy8gJ2ZyLUZSJ1xuLy8gJ2hlLUlMJyB5ZXNcbi8vICdodS1IVSdcbi8vICdpdC1JVCdcbi8vICdqYS1KUCdcbi8vICdrby1LUidcbi8vICdsdi1MVidcbi8vICduYi1OTydcbi8vICdubC1OTCdcbi8vICdwbC1QTCdcbi8vICdwdC1CUidcbi8vICdwdC1QVCdcbi8vICdydS1SVSdcbi8vICdzdi1TRSdcbi8vICd0ci1UUidcbi8vICd6aC1IQU5TJ1xuLy8gJ3poLUhBTlQnXG4vLyAnemgtWVVFJ1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRSVExMaXN0KCk6IHN0cmluZ1tdIHtcbiAgY29uc3QgcnRsTGlzdCA9IFsnYXItRUcnLCAnYXItSk8nLCAnYXItU0EnLCAnaGUtSUwnXTtcblxuICByZXR1cm4gcnRsTGlzdDtcbn1cbiJdfQ==